import {
  Box,
  Typography,
  Button,
  Snackbar,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ja } from "date-fns/locale";
import { ReportStyle as styles } from "./ReportStyle";
import UserListTable from "../components/Table/UserListTable";
import { useReport } from "../hooks/logic/useReport";
import ManagementUsersDialog from "../components/ManagementUsersDialog";
import UserReportTable from "../components/Table/UserReportTable";

const Report = () => {
  const {
    inputRef,
    userList,
    selectedRow,
    checkedIds,
    handleCheckChange,
    handleUpdate,
    handleRowClick,
    detailDialogOpen,
    setDetailDialogOpen,
    toastOpen,
    toastMessage,
    toastSeverity,
    handleCloseToast,
    handleApprove,
    handleCancel,
    handleDelete,
    handleCheckChangeAll,
    selectedMonth,
    setSelectedMonth,
    monthOptions,
    handleMonthChange,
    handleItemCsv,
    handlePlanCsv,
  } = useReport();

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ja}>
      <ManagementUsersDialog
        open={detailDialogOpen}
        onClose={() => {
          // setSelectedParent(null);
          setDetailDialogOpen(false);
        }}
        statusId={4}
        userInfo={selectedRow!}
        onUpdate={handleUpdate}
      />
      <Box sx={styles.titleBar}>
        <Typography variant="h6" sx={styles.titleText}>
          レポート集計
        </Typography>
      </Box>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mb={2}
      >
        {/* 出荷月プルダウン */}
        <FormControl size="small" sx={{ minWidth: 160 }}>
          <InputLabel id="shipping-month-label">出荷月</InputLabel>
          <Select
            labelId="shipping-month-label"
            value={selectedMonth}
            onChange={handleMonthChange}
            label="出荷月"
          >
            {monthOptions.map((month) => (
              <MenuItem key={month} value={month}>
                {month}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* ボタン群 */}
        <Box display="flex" gap={2} marginRight={8}>
          <Button variant="contained" color="error">
            全表示
          </Button>
          <Button variant="contained" color="error">
            合計のみ表示
          </Button>
          <Button variant="contained" color="error">
            Toggle filtering
          </Button>
          <Button variant="contained" color="error">
            CSV出力
          </Button>
          <Button variant="contained" color="error" onClick={handleItemCsv}>
            アイテムCSV出力
          </Button>
          <Button variant="contained" color="error" onClick={handlePlanCsv}>
            プランCSV出力
          </Button>
        </Box>
      </Box>

      <Box py={0} px={0}>
        <Box mt={2}>
          <UserReportTable
            data={[]}
            checkedIds={checkedIds}
            onCheckedChange={handleCheckChange}
            onCheckedChangeAll={handleCheckChangeAll}
            // onRowClick={handleRowClick}
          ></UserReportTable>
          {/* チェック件数 & ボタンを下部に固定表示 */}
          {checkedIds.size > 0 && (
            <Box
              sx={{
                position: "fixed",
                bottom: 0,
                right: 0,
                width: "100%",
                bgcolor: "white",
                borderTop: "1px solid #ccc",
                p: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 1000,
              }}
            >
              <Box gap={2} sx={{ marginLeft: "240px" }}>
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <Typography>全{checkedIds.size}件選択されています</Typography>
                </Box>

                <Box display="flex" gap={2}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleApprove}
                  >
                    承認する
                  </Button>
                  <Button variant="outlined" onClick={handleCancel}>
                    キャンセル
                  </Button>
                  <Button
                    variant="contained"
                    color="error"
                    onClick={handleDelete}
                  >
                    ユーザー削除
                  </Button>
                </Box>
              </Box>
            </Box>
          )}
        </Box>
      </Box>
      <Snackbar
        open={toastOpen}
        autoHideDuration={4000}
        onClose={handleCloseToast}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={handleCloseToast}
          severity={toastSeverity}
          sx={{ width: "100%" }}
          elevation={6}
          variant="filled"
        >
          {toastMessage}
        </MuiAlert>
      </Snackbar>
    </LocalizationProvider>
  );
};

export default Report;
